export default {
  title: 'AI Suggestions',
  subtitle: 'Suggestions from the FoodAmigos agent for your restaurants.',
  empty: 'Nothing to show here.',
  tabs: {
    pending: 'Pending',
    history: 'History',
  },
  table: {
    id: 'ID',
    company: 'Restaurant',
    type: 'Type',
    summary: 'Suggestion',
    created_at: 'Created',
    status: 'Status',
    actions: 'Actions',
  },
  statuses: {
    pending: 'Pending',
    confirmed: 'Confirmed',
    applied: 'Applied',
    rejected: 'Rejected',
    failed: 'Failed',
    expired: 'Expired',
  },
  types: {
    'smart_pricing.global_reduce': 'Whole-menu discount',
    'smart_pricing.category_reduce': 'Category discount',
    'competitor_listing.confirm': 'Confirm marketplace listing',
    'catalog.price_correct': 'Price correction',
    'catalog.add_item': 'Add missing item',
    'catalog.quality': 'Content quality',
    'catalog.reorder': 'Menu reorder',
  },
  actions: {
    review: 'Review',
    confirm: 'Confirm',
    reject: 'Reject',
    cancel: 'Cancel',
    edit: 'Edit',
  },
  edit: {
    label: 'Describe the change you want (a new revision is generated)',
    placeholder: 'Describe the change you want',
    placeholders: {
      'smart_pricing.global_reduce': 'e.g. make it 15%, rename it to “Summer -15%”, or run it on delivery only',
      'smart_pricing.category_reduce': 'e.g. set the Drinks discount to 10% and drop pickup',
      'catalog.price_correct': 'e.g. remove the “Cola” correction, or set “Pizza” to €7.50',
      'catalog.add_item': 'e.g. remove the “Water” item, or price “Falafel Wrap” at €6.50',
      'catalog.quality': 'e.g. remove the “Fries” and “Cola” items from the list',
      'catalog.reorder': 'e.g. put Drinks last and move the bestseller to the top of Bowls',
      'competitor_listing.confirm': 'e.g. replace the Uber Eats link with https://…, or add Wolt: https://…',
    },
    submit: 'Generate revision',
  },
  revisions: {
    label: 'Revision',
    original: 'Original',
    revision_n: 'Revision {{n}}',
  },
  detail: {
    title: 'Suggestion detail',
    targets: 'Affected items',
    evidence: 'Why the agent suggests this',
    no_targets: 'No item details provided.',
    composed_from: 'Composed from',
    items_suffix: 'items',
    nutrition: 'Nutrition',
    uncategorized: 'Uncategorized',
    decided_by: 'Decided by',
    decision_note: 'Note',
    category_existing: 'existing',
    category_new: 'new',
    product: 'Product',
    price_change: 'Price change',
    no_items: 'No items',
    fills_image: '+ image',
    fills_description: '+ description',
    fills_nutrition: '+ nutrition',
    fills_modifiers: '+ modifiers',
    competitor_links: 'Competitor links',
    no_competitor_links: 'No resolved competitor links yet.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Reject this suggestion',
    note_label: 'Reason',
    note_placeholder: 'Briefly explain why you are rejecting this suggestion',
  },
  toasts: {
    load_failed: 'Failed to load suggestions',
    confirmed: 'Suggestion confirmed',
    rejected: 'Suggestion rejected',
    action_failed: 'Could not complete that action',
    revision_created: 'New revision generated',
    revision_failed: 'Could not generate a revision from that instruction',
    choose_revision: 'This suggestion has multiple revisions — open it and pick one to confirm',
  },
};
